import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import Service from './Service'

export const getPortfolioByOrgId = createAsyncThunk(
  'common/popupManagePortfolio/getPortfolioByOrgId',
  async (params, { rejectWithValue }) => {
    try {
      const res = await Service.getPortfolioByOrgId(params)
      return res.success ? res.data : rejectWithValue({ loading: false })
    } catch (error) {
      return rejectWithValue({ loading: axios.isCancel(error) })
    }
  },
)

export const addNewCompany = createAsyncThunk(
  'common/popupManagePortfolio/addNewCompany',
  async (params, { rejectWithValue }) => {
    try {
      const res = await Service.addNewCompany(params)
      return res.success ? res.data : rejectWithValue({ loading: false })
    } catch (error) {
      return rejectWithValue({ loading: axios.isCancel(error) })
    }
  },
)

export const deleteCompany = createAsyncThunk(
  'common/popupManagePortfolio/deleteCompany',
  async (params, { rejectWithValue }) => {
    try {
      const res = await Service.deleteCompany(params)
      return res.success ? res.data : rejectWithValue({ loading: false })
    } catch (error) {
      return rejectWithValue({ loading: axios.isCancel(error) })
    }
  },
)

export const postCreatePortfolio = createAsyncThunk(
  'portfolioInsights/common/postCreatePortfolio',
  async (params, { rejectWithValue }) => {
    try {
      const res = await Service.postCreatePortfolio(params)

      return res.success
        ? res.data
        : rejectWithValue({
            loading: false,
            message: res.data.errors[0],
          })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }

      return rejectWithValue({
        loading: false,
        message: error.response.data.errors[0],
      })
    }
  },
)
